const dev = {
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://api.coffeelist.dev.dahof.de"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_pCib9RraB",
    APP_CLIENT_ID: "10ci2ata5qrde8buasabi1vkpc",
    IDENTITY_POOL_ID: "us-east-1:fa09fff4-37bc-431a-961f-993ec8c87f41"
  }
};

const prod = {
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://api.coffeelist.dahof.de"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_YytFw7SLT",
    APP_CLIENT_ID: "183oa4dkbv2tpslp83fmn6elrh",
    IDENTITY_POOL_ID: "us-east-1:7f7b9e64-c95d-4650-9bdc-66d966ecb11e"
  }
}
console.log(`Using config for ${process.env.VUE_APP_STAGE}`);
const config = process.env.VUE_APP_STAGE === 'production'
  ? prod
  : dev;

export default {
  ...config
};